// Copyright Epic Games, Inc. All Rights Reserved.

/**
 * Registers the Special Key codes
 *  Must be kept in sync with JavaScriptKeyCodeToFKey C++ array.
 * The index of the entry in the array is the special key code given below.
 */
export class SpecialKeyCodes {
    static backSpace = 8;
    static shift = 16;
    static control = 17;
    static alt = 18;
    static rightShift = 253;
    static rightControl = 254;
    static rightAlt = 255;
}
